<template>
  <div class="c-donut-chart">
    <p class="card-title">{{ title }}</p>
    <div class="donut-inner">
      <div class="legend">
        <div v-for="(slice, i) in slices" :key="i" class="legend-item">
          <div class="dot" :style="{ background: slice.color }"></div>
          <span class="lbl">{{ slice.key }}</span>
          <span class="cnt">{{ slice.val.toLocaleString() }}</span>
          <span class="pct">{{ (slice.pct * 100).toFixed(1) }}%</span>
        </div>
      </div>
      <svg :viewBox="`0 0 ${size} ${size}`" width="300" height="300">
        <circle
          v-for="(slice, i) in slices" :key="i"
          :cx="cx" :cy="cy" :r="r" fill="none"
          :stroke="slice.color" :stroke-width="strokeWidth"
          :stroke-dasharray="`${slice.dash} ${slice.gap}`"
          :stroke-dashoffset="slice.dashOffset"
        />
        <text :x="cx" :y="cy" text-anchor="middle" dominant-baseline="middle" class="svg-total">
          {{ total.toLocaleString() }}
        </text>
        <text :x="cx" :y="cy + 11" text-anchor="middle" class="svg-label">всего</text>
      </svg>
    </div>
  </div>
</template>

<script>
const COLORS = [ '#378ADD', '#1D9E75', '#D4537E', '#BA7517', '#7F77DD', '#D85A30', '#639922', '#E24B4A', ]

export default {
  name: 'CDonutChart',
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      size: 100,
      strokeWidth: 11,
    }
  },
  computed: {
    cx() {
      return this.size / 2
    },
    cy() {
      return this.size / 2
    },
    r() {
      return 38
    },
    circ() {
      return 2 * Math.PI * this.r
    },
    total() {
      return Object.values(this.data).reduce((s, v) => s + v, 0)
    },
    slices() {
      let offset = 0
      return Object.entries(this.data).map(([ key, val, ], i) => {
        const pct = val / this.total
        const dash = pct * this.circ
        const gap = this.circ - dash
        const dashOffset = this.circ / 4 - offset
        offset += dash
        return {
          key,
          val,
          pct,
          dash,
          gap,
          dashOffset,
          color: COLORS[i % COLORS.length],
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-donut-chart {
  border: 1px solid #e0e0e0;
  padding: 5px 0 5px 10px;
  border-radius: 16px;
  .card-title {
    font-size: 18px;
    color: #000000;
    margin: 0 0 12px;
    font-weight: 400;
  }

  .donut-inner {
    display: flex;
    align-items: center;
    gap: 20px;

    svg {
      flex-shrink: 0;

      .svg-total {
        font-size: 10px;
        font-weight: 500;
        fill: #222;
      }

      .svg-label {
        font-size: 7px;
        fill: #888;
      }
    }
  }

  .legend {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .legend-item {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 18px;

      .dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        flex-shrink: 0;
      }

      .lbl {
        flex: 1;
        color: #222;
      }

      .cnt {
        color: #888;
        font-size: 14px;
      }

      .pct {
        font-weight: 500;
        font-size: 18px;
        min-width: 40px;
        text-align: right;
      }
    }
  }
}
</style>
